{
  "list": {
    "title": "我的主辦申請",
    "description": "您送出的所有申請主辦競賽紀錄。",
    "newRequest": "申請主辦新競賽",
    "loading": "載入中…",
    "loadError": "無法載入您的申請紀錄。",
    "empty": "您尚未送出任何主辦申請。",
    "columns": {
      "proposedName": "提案競賽名稱",
      "status": "狀態",
      "submittedAt": "送出時間"
    }
  },
  "form": {
    "title": "申請主辦新競賽",
    "description": "送出後由平台管理者審核；核准後系統會自動建立競賽並授予您該競賽的管理員權限，不需要另外申請。",
    "proposedName": "提案競賽名稱",
    "proposedSlug": "提案網址代稱",
    "proposedSlugHint": "僅限小寫英數字與連字號，例如 my-competition-2026。",
    "organization": "主辦單位",
    "contactPerson": "聯絡人",
    "contactEmail": "聯絡 Email",
    "description": "競賽目的與說明",
    "timezone": "時區",
    "expectedStartAt": "預計開始時間",
    "expectedEndAt": "預計結束時間",
    "expectedParticipants": "預計參賽人數",
    "judgingRequired": "需要評審評分",
    "twoRoundRequired": "需要兩階段賽程",
    "studentMinorData": "涉及學生／未成年人資料",
    "notes": "其他備註",
    "submit": "送出申請",
    "submitting": "送出中…",
    "error": "送出失敗，請確認欄位內容後再試一次。",
    "cancel": "取消"
  },
  "detail": {
    "loading": "載入中…",
    "loadError": "無法載入此申請。",
    "backToList": "← 回到我的申請",
    "applicant": "申請人資料",
    "fields": {
      "proposedName": "提案競賽名稱",
      "proposedSlug": "提案網址代稱",
      "organization": "主辦單位",
      "contactPerson": "聯絡人",
      "contactEmail": "聯絡 Email",
      "description": "競賽目的與說明",
      "timezone": "時區",
      "expectedStartAt": "預計開始時間",
      "expectedEndAt": "預計結束時間",
      "expectedParticipants": "預計參賽人數",
      "judgingRequired": "需要評審評分",
      "twoRoundRequired": "需要兩階段賽程",
      "studentMinorData": "涉及學生／未成年人資料",
      "notes": "其他備註",
      "submittedAt": "送出時間",
      "reviewedAt": "審核時間"
    },
    "yes": "是",
    "no": "否",
    "none": "無",
    "reviewReason": {
      "changesRequested": "平台管理者要求補充／修改以下內容：",
      "rejected": "平台管理者拒絕此申請，原因：",
      "approved": "審核備註："
    },
    "cancel": "撤回申請",
    "cancelConfirmTitle": "撤回主辦申請",
    "cancelConfirmImpact": "撤回後此申請將結束審核流程，若仍要主辦競賽需重新提出申請。",
    "cancelSuccess": "申請已撤回。",
    "reapply": "提出新的申請",
    "approvedBanner": "此申請已核准，競賽已建立，您已是該競賽的管理員。",
    "goToCompetition": "前往管理主辦後台 →"
  }
}
